import { message } from 'antd';
import {sleep} from '@/utils';
import {refreshToken} from '@/api'

const isPro = process.env.NODE_ENV === 'production'
const API_URL = process.env.REACT_APP_API_URL

const NOT_TOKEN_API = [
  '/auth/oauth2/token'
]
export default async function sendRequest(url:any, options?:any) {
  const {
    method = 'GET', 
    headers = {
      'Content-Type': 'application/json',
      // 'Authorization':'Basic anR4LWx1bmFyOjEyMzQ1Ng==',
    }, 
    body = null,
    __isRefresh=false
  } = options||{}
  const tokenInfo = JSON.parse(localStorage.getItem('tokenInfo')||'{}')
  // 非token接口，headers需要添加Authorization
  if(
    // !/(oauth2\/token)|(captcha\/email)|(\/front\/report)|(\/available\/date)|(\/cost\/date)/.test(url)
    NOT_TOKEN_API.findIndex((s:string)=>url.includes(s))===-1
  ) {
    if(tokenInfo && tokenInfo.access_token) {
      headers['Authorization'] = 'Bearer ' + tokenInfo.access_token
    }else {
      // message.error('token 丢失请重新登陆')
      // await sleep(1000)
      // message.error('正在跳转登录页')
      // await sleep(1000)
      // window.location.href = '/login'
    }
  }else {
  }

  // 构建请求配置
  const requestOptions = {
    method,
    headers,
    __isRefresh,
    body: body ? JSON.stringify(body) : null,
  };

  const _url  = (isPro?API_URL+'/api':'/api')+ url
  // console.log('/request.ts [51]--1','_url',_url);
  // 发起请求并返回 Promise 对象
  return fetch(_url, requestOptions)
    .then(async (response) => {
      const {status} = response
      const contentType = response.headers.get('content-type') || ''
      const isJson = contentType.includes('application/json') || contentType.includes('+json')

      if (!isJson) { //适配 excel 导出
        const blob = await response.blob()
        if (status === 200) return blob
        let text = ""
        try {
          text = await blob.text()
        } catch (e) {
        }
        text && message.error(text)
        return { error: text || "error" }
      }

      const res = await response.json()
      // console.log('/request.ts [53]--1','res',status,res);
      if(status ===200) {
        if(res.status === 200) {
          return res
        }else {
          res.message && message.error(res.message)
          return res
        }
        // 解析响应数据
        return res;
      }else if(status ===401 && !requestOptions.__isRefresh && NOT_TOKEN_API.findIndex((s:string)=>url.includes(s))===-1) {
        // console.log('/request.ts [68]--1','res',res,status);
        // message.error('token过期，正在重新获取')
        // const refresh = await refreshToken()
        // await sleep(100)
        // if(refresh) {
        //   const resp:any = await sendRequest(url,options)
        //   return resp
        // }else {
        //   message.error(res.message)
        //   return res
        // }
        message.error(res.message)
        window.location.href = '/login'
        return res
      }else {
        console.log('/request.ts [72]====>--1','res-error',res);
        res && message.error(res.message||res.error_description||res.error)
        return res||{}
      }
    })
    .catch(async (error) => {
      console.log('/request.ts [77]--1','error',error);
      // 错误处理逻辑
      message.error('请求失败')
      return {error:'error'}
      
    })
}



export async function exportRequest(url:any, options?:any) {
  const {
    method = 'GET', 
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      // 'Authorization':'Basic anR4LWx1bmFyOjEyMzQ1Ng==',
    }, 
    body = null
  } = options||{}

  const tokenInfo = JSON.parse(localStorage.getItem('tokenInfo')||'{}')
  // 非token接口，headers需要添加Authorization
  if(tokenInfo && tokenInfo.access_token) {
    headers['Authorization'] = 'Bearer ' + tokenInfo.access_token
  }else {
    message.error('token 丢失请重新登陆')
    await sleep(1000)
    message.error('正在跳转登录页')
    await sleep(1000)
    window.location.href = '/login'
  }
  
  // 构建请求配置
  const requestOptions = {
    method,
    headers,
    body: body ? JSON.stringify(body) : null,
  };

  const _url  = (isPro?API_URL+'/':'')+ url
  // 发起请求并返回 Promise 对象
  return fetch(_url, requestOptions)
    .then(async (response) => {
      const blob = await response.blob()
      // const downloadLink = document.createElement('a');
      // downloadLink.href = URL.createObjectURL(blob);
      // downloadLink.download = '数据导出.xlsx';

      // // 触发下载
      // downloadLink.click();

      // // 清理下载链接
      // URL.revokeObjectURL(downloadLink.href);
      return blob
    })
    .catch(async(error) => {
      // 错误处理逻辑
      message.error('请求失败')
      return {error:'error'}
      
    })
}


export async function UploadRequest(url:any, options?:any) {
  const {
    method = 'POST', 
    headers = {
      // 'Content-Type': 'multipart/form-data',
      // 'Authorization':'Basic anR4LWx1bmFyOjEyMzQ1Ng==',
    }, 
  } = options||{}

  const tokenInfo = JSON.parse(localStorage.getItem('tokenInfo')||'{}')
  // 非token接口，headers需要添加Authorization
  if(tokenInfo && tokenInfo.access_token) {
    headers['Authorization'] = 'Bearer ' + tokenInfo.access_token
  }else {
    message.error('token 丢失请重新登陆')
    await sleep(200)
    message.error('正在跳转登录页')
    await sleep(200)
    window.location.href = '/login'
  }
  
  const formData = new FormData()
  const {file} = options
  formData.append('file', file);
  // console.log('/request.ts [173]--1','file',file);
  // 构建请求配置
  const requestOptions = {
    method,
    headers,
    body: formData,
  };

  const _url  = (isPro?API_URL+'/api':'/api')+ url
  // 发起请求并返回 Promise 对象
  return fetch(_url, requestOptions)
    .then(async (response) => {
      const res = await response.json()
      return res
    })
    .then(async (res) => {
      if(res.status === 200) {
        return res
      }else {
        res.message && message.error(res.message)
        return null
      }
    })
    .catch(async(error) => {
      console.log('/request.ts [190]--1','error',error);
      // 错误处理逻辑
      message.error('请求失败')
      return {error:'error'}
      
    })
}
